/**
 * enShopifyBilling — Settings → Billing copy for merchants whose plan is billed by
 * Shopify (App Store 1.2.3: a plan can be dropped to Free in the app, without
 * support or an uninstall).
 *
 * Split out of `en.ts`, which sits at the 500-line ceiling the `fileSize`
 * ratchet enforces.
 */
export const enShopifyBilling = {
  'billing.downgrade.title': 'Move to the Free plan',
  'billing.downgrade.body': 'Your {plan} plan is billed through Shopify. Cancel it here to move to Free — Shopify stops charging for it.',
  'billing.downgrade.button': 'Downgrade to Free',
  'billing.downgrade.confirmTitle': 'Downgrade to Free?',
  'billing.downgrade.confirmBody': 'Your {plan} plan is cancelled in Shopify now, and your workspace moves to the Free plan with its limits. You can choose a paid plan again at any time.',
  'billing.downgrade.confirm': 'Yes, downgrade to Free',
  'billing.downgrade.cancel': 'Keep my plan',
  'billing.downgrade.working': 'Cancelling…',
  'billing.downgrade.failed': 'The plan could not be cancelled. Try again, or cancel it in your Shopify admin under Settings → Apps.',
} as const;
